import { Injectable } from '@angular/core';
import type { CardDescriptorInterface } from '@zaoblako/shared/common/dtos/card/card-descriptor.dto';
import type { HistoryPageInterface } from '@zaoblako/shared/common/dtos/history/history-page.dto';
import type { ReportDescriptorInterface } from '@zaoblako/shared/common/dtos/report/report-descriptor.dto';
import type { EntityCardHistoryQueryInterface } from '@zaoblako/shared/common/dtos/history/entity-card-history-query.dto';
import type { PaginationQueryInterface } from '@zaoblako/shared/common/dtos/pagination-query.dto';
import type { ResidentCarFindInterface } from '@zaoblako/shared/modules/cctv/dtos/resident-car/resident-car-find.dto';
import type { ResidentCarPageInterface } from '@zaoblako/shared/modules/cctv/dtos/resident-car/resident-car-page.dto';
import type { ResidentCarQueryInterface } from '@zaoblako/shared/modules/cctv/dtos/resident-car/resident-car-query.dto';
import type { ResidentCarSumsFindInterface } from '@zaoblako/shared/modules/cctv/dtos/resident-car/resident-car-sums-find.dto';
import { BaseService } from '@zaoblako/web/core/services/base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResidentCarService extends BaseService {
  protected baseUrl = '/cctv/parking/resident-car';

  public getRegistryDescriptor(): Observable<ReportDescriptorInterface> {
    return this.http.get<ReportDescriptorInterface>(`${this.baseUrl}/registry-descriptor`);
  }

  public getCardDescriptor(): Observable<CardDescriptorInterface> {
    return this.http.get<CardDescriptorInterface>(`${this.baseUrl}/card-descriptor`);
  }

  public findPage(queryParams: ResidentCarQueryInterface): Observable<ResidentCarPageInterface> {
    return this.http.get<ResidentCarPageInterface>(this.baseUrl, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public findResidentCarsSums(queryParams?: ResidentCarQueryInterface): Observable<ResidentCarSumsFindInterface> {
    return this.http.get<ResidentCarSumsFindInterface>(`${this.baseUrl}/sums`, {
      params: queryParams ? this.objectToHttpParams(queryParams) : {}
    });
  }

  public restore(id: number): Observable<ResidentCarFindInterface> {
    return this.http.post<ResidentCarFindInterface>(`${this.baseUrl}/${id}/restore`, null);
  }

  public getHistory(
    id: number,
    queryParams: EntityCardHistoryQueryInterface | PaginationQueryInterface
  ): Observable<HistoryPageInterface> {
    return this.http.get<HistoryPageInterface>(`${this.baseUrl}/${id}/history`, {
      params: this.objectToHttpParams(queryParams)
    });
  }

  public passCar(taskId: number, roomId: number): Observable<ResidentCarFindInterface> {
    return this.http.post<ResidentCarFindInterface>(`${this.baseUrl}/${taskId}/pass-car/${roomId}`, null);
  }
}
